import {
  SyncActionBase,
  usePrivateSyncAction,
  UseSyncActionProps,
} from 'modules/integrations/hooks/usePrivateSyncAction'

type UseHeaderSyncActionReturn = {
  headerSyncActions: SyncActionBase[]
  syncModal: React.ReactNode | null
}

export const useHeaderSyncAction = (props: UseSyncActionProps = {}): UseHeaderSyncActionReturn => {
  const { syncActions, syncModal } = usePrivateSyncAction(props)

  return {
    headerSyncActions: syncActions,
    syncModal,
  }
}
